import React from 'react';
import { PureAlert as Alert } from '../alert.component';

type FormAlertProps = {
  hidden: boolean,
  content: string | React.ReactNode,
  type: string
}
const FormAlert = ({ hidden, content, type }: FormAlertProps) => (
  <div className="form-alert" hidden={hidden}>
    <Alert content={content} type={type} show={!hidden}/>
  </div>
);

export default FormAlert;
